'use client';
import { isBrowser } from '@s7/platform';

var getCookie = function(name) {
    if (!isBrowser()) {
        return;
    }
    var match = document.cookie.match(new RegExp("(^| )" + name + "=([^;]+)"));
    if (match) {
        return match[2];
    }
};

export { getCookie };
